<template>
  <div>
    <div class="wrap-select">
      <div class="select-weeks" @click="weekIShow=true">
        <span class="select-weeks-name">{{nowSesstionWeekName}}</span>
        <van-icon name="arrow-down" />
      </div>
      <div class="select-weeks-date">
        <div v-for="(item,i) in weekData" :key="item.weekName" class="select-weeks-date-box">
          <div class="select-weeks-date-box-div" :class="i===isIndex?'active':''" @click="changeWeekData(item,i)">
            <div class="select-weeks-date-box-div-text">{{item.weekName}}</div>
            <div class="select-weeks-date-box-div-time">{{item.time}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="classDataList.length>0">
      <template v-for="item in classDataList">
        <div 
          :key="item.ClassTableGenerateBaseID" 
          v-if="xy.moment(item.ClassDate, 'YYYY-MM-DD').format('MM-DD')===checkedTime">
          <div
            class="class-data-box">
            <div class="class-data-box-left">第{{item.AMorPMOrder+1}}节</div>
            <div class="class-data-box-center nowrap">
              <div class="title nowrap">{{item.SubjectName}}&nbsp;{{item.CollectionName}}</div>
              <div class="desr nowrap">
                <div class="nowrap">时间：{{xy.moment('2020/01/01 '+item.StartTime).format('HH:mm')}}-{{xy.moment('2020/01/01 '+item.EndTime).format('HH:mm')}}</div>
                <div v-if="item.HouseID" style="width:80%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                  地点：{{item.SchoolDistrictName}}
                  <span v-if="item.BuildingName">-{{item.BuildingName}}</span>
                  <span v-if="item.HouseName">-{{item.HouseName}}</span>
                </div>
              </div>
            </div>
          </div>        
          <div
            v-if="isShow"
            class="class-data-box-bottom" 
            @click="getIsShow(item)">
              <span>评价学生</span>
              <van-icon name="arrow" />
          </div>
        </div>
      </template>
    </div>
    <div v-else class="null-data">
      <img src="@/assets/common/moblie-no-data.png" />
      <div>暂无数据</div>
    </div>
    <van-popup v-model="weekIShow" position="bottom" :style="{ height: '45%' }">
      <van-picker
        show-toolbar
        :default-index="nowSesstionWeekIndex"
        :columns="nowSesstionWeek"
        @confirm="onConfirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  name:'evaStudentWrap',
  data() {
    return {
      isShow:false,
      isIndex:0,
      weekIShow:false,
      nowSesstionWeekName:'',
      nowSesstionWeekVal:'',
      nowSesstionWeekIndex:'',
      nowSesstionWeek:[],
      yearSessionData:[],
      yearSession:[],
      weekData:[],
      classDataList:[],
      checkedTime:'',
      studentGradeForStudentYearID:'',
      schoolDistrictID:'',
      startDateText:'',
      endDateText:''
    }
  },
  created(){
    this.getSchoolGrade()
    this.getSessionNodeList()
  },
  methods:{
    getIsShow(val) {
      this.xyapi.get(`${this.$store.state.apiPath}/api/ProgrammeSetting/GetProgrammeByDisciplineID`,{
        disciplineID:val.DisciplineID,
        academicSessionID:val.AcademicSessionID,
        schoolDistrictID:val.SchoolDistrictID,
        studentGradeForStudentYearID:val.StudentGradeForStudentYearID
      }).then(res=>{
        if(res.success){
          if(res.data.HasProgramme){
            this.go(val,res.data.HasGroup)
          }else{
            this.xy.msgError('该课程未设置评价方案')
          }
        }
      })
    },
    go(data,val){
      let obj={
        ClassTableGenerateBaseID:data.ClassTableGenerateBaseID,
        SchoolDistrictID:data.SchoolDistrictID,
        AcademicYearID:data.AcademicYearID,
        AcademicSessionID:data.AcademicSessionID,
        StudentGradeForStudentYearID:data.StudentGradeForStudentYearID,
        DisciplineID:data.DisciplineID,
        CoursePlanAID:data.CoursePlanAID,
        CoursePlanAIDType:data.CoursePlanAIDType,
        StudentOrganizationID:data.StudentOrganizationID,
        AMorPMOrder:data.AMorPMOrder+1,
        ClassDate:data.ClassDate,
        DisciplineName:data.DisciplineName,
        HasGroup:val
      }
      this.$store.commit('evaluation/changeAverageObj', obj)
      this.$router.push({
        path:'/home/evaStudent'
      })
    },
    cancel(){
      this.weekIShow=false
    },
    onConfirm(val,index){
      if(val.text === "本周"){
        this.isShow=true
      }else{
        this.isShow=false
      }
      this.nowSesstionWeekName=val.text
      this.nowSesstionWeekVal=val.date
      this.nowSesstionWeekIndex=index
      this.weekIShow=false
      this.getWeeks()
    },
    // 获取校区、年级
    getSchoolGrade () {
      this.xy.loading()
      this.xyapi.get(`${this.xyMApi}/xy/comm/GetSchoolDistrictForStudentGradeStudentYears`).then(res => {
        this.xy.unloading()
        if (res.success) {
          this.schoolGradeList = res.data
          if (this.schoolGradeList.length > 0 && this.schoolGradeList[0].Childrens.length > 0) {
            this.schoolDistrictID=this.schoolGradeList[0].ID
            this.studentGradeForStudentYearID=this.schoolGradeList[0].Childrens[0].StudentYearForSchoolDistrictID
            let obj={}
            obj.schoolDistrictID = this.schoolDistrictID
            obj.studentGradeForStudentYearID = this.studentGradeForStudentYearID
            this.$store.commit('evaluation/changeSchoolObj', obj)
          }
        }
      })
    },
    // 获取学年获取学期
    async getSessionNodeList () {
      this.xy.loading()
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/GetSessionNodeList`)
      this.xy.unloading()
      if (res.success) {
        this.yearSessionData = res.data
        this.yearSession = []
        var index = this.yearSessionData.map((item) => { return item.IsCurrent }).indexOf(true)
        if (index !== -1) {
          this.yearSession.push(this.yearSessionData[index].value)
          var index1 = this.yearSessionData[index].children.map((item) => { return item.IsCurrent }).indexOf(true)
          if (index1 !== -1) {
            this.yearSession.push(this.yearSessionData[index].children[index1].value)
            this.startDateText=this.yearSessionData[index].children[index1].StartDate
            this.endDateText=this.xy.moment(new Date()).format('YYYY-MM-DD')
            let obj={}
            obj.startDateText = this.startDateText
            obj.endDateText = this.endDateText
            this.$store.commit('evaluation/changeTimeObj', obj)
          }
        } else {
          for (var i = 0; i < this.yearSessionData.length; i++) {
            if (this.yearSessionData[i].children.length > 0) {
              this.yearSession = [this.yearSessionData[i].value, this.yearSessionData[i].children[0].value]
              this.startDateText=this.yearSessionData[i].children[0].StartDate
              this.endDateText=this.xy.moment(new Date()).format('YYYY-MM-DD')
              let obj={}
              obj.startDateText = this.startDateText
              obj.endDateText = this.endDateText
              this.$store.commit('evaluation/changeTimeObj', obj)
              return false
            }
          }
        }
        this.getWeek()
      }
    },
    getWeek(){
      this.nowSesstionWeek=[]
      this.xyapi.get(`${this.$store.state.apiPath}/api/Evaluation/GetWeek`).then(res=>{
        if(res.success){
          for(let i=0,len=res.data.length;i<len;i++){
            this.nowSesstionWeek.push({
              text:res.data[i].Week==='本周'?'本周':res.data[i].Week+'周',
              week:res.data[i].Week,
              date:res.data[i].Date,
            })
            if(res.data[i].Week==='本周'){
              this.nowSesstionWeekName=res.data[i].Week
              this.nowSesstionWeekVal=res.data[i].Date
              this.nowSesstionWeekIndex=i
              this.isShow=true
            }else{
              // this.nowSesstionWeekName=res.data[0].Week
              // this.nowSesstionWeekVal=res.data[0].Date
              // this.nowSesstionWeekIndex=0
              // this.isShow=true
            }
          }
          this.getWeeks()
        }
      })
    },
    getWeeks(){
      this.weekData = []
      for (let i = 0; i < 7; i++) {
        this.weekData.push({
          weekName: this.xy.getChinesesWeekForNumSmall(i),
          time:this.xy.moment(this.nowSesstionWeekVal, 'YYYY-MM-DD').add(i, 'days').format('MM-DD')
        })
      }
      this.checkedTime=this.weekData[0].time
      this.xyapi.get(this.$store.state.apiPath+'/api/EvaluateStudent/GetClassTable',{ start: this.nowSesstionWeekVal }).then(res=>{
        if(res.success){
          this.classDataList=res.data
        }
        this.xy.unloading()
      })
    },
    changeWeekData(val,i){
      this.isIndex=i
      this.checkedTime=val.time
    }
  }
}
</script>  
<style lang="less" scoped>
.wrap-select{
  height:124px;
  width:100%;
  background: #fff;
  position: relative;
  overflow: hidden;
  .select-weeks{
    width:133px;
    height:124px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 4px 0px rgba(77,77,77,0.1); 
    .select-weeks-name{
      margin-right:6px;
    }
  }
  .select-weeks-date{
    position: absolute;
    top:0;
    left:133px;
    display: flex;
    height: 124px;
    align-items: center;
    padding-left:20px;
    overflow-x: auto;
    overflow-y: hidden;
    width: calc(100% - 133px);
    .select-weeks-date-box{
      display: flex;
      .select-weeks-date-box-div{
        width: 130px;
        height: 92px;
        text-align: center;
        margin-right:22px;
        background: #f5f5f5;
        border: 1px solid #e8e8e8;
        border-radius: 2px;
        display: flex;
        flex-flow: column;
        justify-content: center;
        .select-weeks-date-box-div-text{
          font-size: 26px;
        }
        .select-weeks-date-box-div-time{
          font-size: 24px;
        }
      }
      .select-weeks-date-box-div.active{
        border: 1px solid #4196ff;
        background: #fff;
        color:#4196ff;
      }
    }    
  }
}
.class-data-box{
  width: 712px;
  height: 200px;
  padding: 20px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin: 20px auto 0;
  .class-data-box-left{
    width: 106px;
    height: 106px;
    line-height: 106px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    background: url(~@/assets/evaluation/classbg.svg) no-repeat left center;
    margin-right: 20px;
  }
  .class-data-box-center{
    flex: 1;
    .title{
      font-size: 30px;
      color: #333;
      margin-bottom:30px;
    }
    .desr{
      font-size: 24px;
      color: #999;
      div:nth-child(1){
        margin-bottom:10px;
      }
    }
  }
}
.class-data-box-bottom{
  width: 712px;
  margin: 0 auto;
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 80px;
  font-size: 28px;
  color: #4196ff;
  background: #fff;
  border-top:1px solid #e5e5e5;
  line-height: 1.15;
  span{
    margin-right:10px;
  }
}
.null-data{
  margin-top:100px;
  text-align: center;
  div{
    font-size: 32px;
  }
}
</style>